import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// PASTE YOUR FIREBASE CONFIG HERE
const firebaseConfig = {
  apiKey: "AIzaSyC-6j7uiZ4GtZF-pXVqKmft0twXtTrfWts",
  authDomain: "best-bets-a805f.firebaseapp.com",
  projectId: "best-bets-a805f",
  storageBucket: "best-bets-a805f.firebasestorage.app",
  messagingSenderId: "77074928338",
  appId: "1:77074928338:web:c97851d4f4fb980706530b"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
